// Philippines Branch Master Mock Data

import SvgIconeye from "../../../../assets/icons/SvgIconeye";

const Productdata = [
  {
    id: 1,
    branchCode: "BR-001",
    branchName: "Head Office",
    branchType: "Head Office",
    address: "6750 Ayala Avenue, Makati City",
    city: "Makati",
    province: "Metro Manila",
    postalCode: "1226",
    contactNumber: "+63 2 8888 1000",
    email: "headoffice@company.ph",
    branchManager: "Miguel Torres",
    employeeCount: 45,
    establishedDate: "01/15/2010",
    status: "Active",
    action: <SvgIconeye/>
  },
  {
    id: 2,
    branchCode: "BR-002",
    branchName: "Makati Branch",
    branchType: "Main Branch",
    address: "Salcedo Village, Makati City",
    city: "Makati",
    province: "Metro Manila",
    postalCode: "1227",
    contactNumber: "+63 2 8888 2000",
    email: "makati@company.ph",
    branchManager: "Roberto Reyes",
    employeeCount: 28,
    establishedDate: "03/20/2012",
    status: "Active",
    action: <SvgIconeye/>
  },
  {
    id: 3,
    branchCode: "BR-003",
    branchName: "Quezon City Branch",
    branchType: "Branch",
    address: "Eastwood City, Libis, Quezon City",
    city: "Quezon City",
    province: "Metro Manila",
    postalCode: "1110",
    contactNumber: "+63 2 8888 3000",
    email: "quezoncity@company.ph",
    branchManager: "Maria Santos",
    employeeCount: 18,
    establishedDate: "06/15/2014",
    status: "Active",
    action: <SvgIconeye/>
  },
  {
    id: 4,
    branchCode: "BR-004",
    branchName: "BGC Taguig Branch",
    branchType: "Branch",
    address: "High Street, BGC, Taguig City",
    city: "Taguig",
    province: "Metro Manila",
    postalCode: "1634",
    contactNumber: "+63 2 8888 4000",
    email: "bgc@company.ph",
    branchManager: "Jose Rizal Santos",
    employeeCount: 22,
    establishedDate: "09/01/2015",
    status: "Active",
    action: <SvgIconeye/>
  },
  {
    id: 5,
    branchCode: "BR-005",
    branchName: "Cebu Branch",
    branchType: "Regional Branch",
    address: "IT Park, Lahug, Cebu City",
    city: "Cebu City",
    province: "Cebu",
    postalCode: "6000",
    contactNumber: "+63 32 888 5000",
    email: "cebu@company.ph",
    branchManager: "Ana Garcia",
    employeeCount: 15,
    establishedDate: "01/20/2016",
    status: "Active",
    action: <SvgIconeye/>
  },
  {
    id: 6,
    branchCode: "BR-006",
    branchName: "Davao Branch",
    branchType: "Regional Branch",
    address: "Abreeza Mall, J.P. Laurel Ave, Davao City",
    city: "Davao City",
    province: "Davao del Sur",
    postalCode: "8000",
    contactNumber: "+63 82 888 6000",
    email: "davao@company.ph",
    branchManager: "Rosa Fernandez",
    employeeCount: 12,
    establishedDate: "05/10/2017",
    status: "Active",
    action: <SvgIconeye/>
  },
  {
    id: 7,
    branchCode: "BR-007",
    branchName: "Clark Branch",
    branchType: "Branch",
    address: "Clark Freeport Zone, Angeles City",
    city: "Angeles City",
    province: "Pampanga",
    postalCode: "2009",
    contactNumber: "+63 45 888 7000",
    email: "clark@company.ph",
    branchManager: "Pedro Martinez",
    employeeCount: 10,
    establishedDate: "11/15/2018",
    status: "Active",
    action: <SvgIconeye/>
  },
  {
    id: 8,
    branchCode: "BR-008",
    branchName: "Cagayan de Oro Branch",
    branchType: "Branch",
    address: "Limketkai Center, CDO",
    city: "Cagayan de Oro",
    province: "Misamis Oriental",
    postalCode: "9000",
    contactNumber: "+63 88 888 8000",
    email: "cdo@company.ph",
    branchManager: "Carlos Mendoza",
    employeeCount: 8,
    establishedDate: "03/01/2019",
    status: "Active",
    action: <SvgIconeye/>
  },
  {
    id: 9,
    branchCode: "BR-009",
    branchName: "Iloilo Branch",
    branchType: "Branch",
    address: "SM City Iloilo, Mandurriao",
    city: "Iloilo City",
    province: "Iloilo",
    postalCode: "5000",
    contactNumber: "+63 33 888 9000",
    email: "iloilo@company.ph",
    branchManager: "Teresa Lopez",
    employeeCount: 9,
    establishedDate: "07/01/2020",
    status: "Active",
    action: <SvgIconeye/>
  },
  {
    id: 10,
    branchCode: "BR-010",
    branchName: "Baguio Branch",
    branchType: "Branch",
    address: "Session Road, Baguio City",
    city: "Baguio City",
    province: "Benguet",
    postalCode: "2600",
    contactNumber: "+63 74 888 0100",
    email: "baguio@company.ph",
    branchManager: "Ricardo Flores",
    employeeCount: 7,
    establishedDate: "01/15/2021",
    status: "Active",
    action: <SvgIconeye/>
  }
];

export default Productdata;